import React, {useEffect, useState} from "react";
import {Route, Switch, useParams} from "react-router-dom";
import { useData } from '../dataContext';
import * as dbServices from "../utils/dbServices";
import NavBar from "./navbar";
import CcrMain from "./csChatRegistration/ccrMain.jsx";
import CcrSubmitSuccess from "./csChatRegistration/ccrSubmitSuccess.jsx";

const styleContainer={
    // "paddingLeft": "20px",
    // "paddingTop": "10px"
    height:"90vh",overflowY:"auto", overflowX:"hidden"
}

const PetrosMain = (props) =>{

    const { updateDataAll } = useData();

    //data download & context save here
    useEffect(() => {
        getData();
    },[])

    const getData = async () =>{
        const temp = await dbServices["getDataAll"]()
        console.log(temp)
        updateDataAll(temp)
    }



    return(
        <div style={{overflowY:"clip"}}>
            <NavBar style={{height:"10vh"}}/>
            <div className="content" style={styleContainer}>
                <Switch>
                    <Route path="/ccr/:ccrId" component={CcrMain} />
                    <Route path="/ccrSubmitSuccess" component={CcrSubmitSuccess} />
                </Switch>
            </div>
        </div>
    )
}

export default PetrosMain